import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppComponent } from '../components/root/app.component';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http'; 
import { environment } from '../../environments/environment';
import { AppConfig } from '../app.config';
import { ProgressHttpModule } from 'angular-progress-http';
import { HttpModule } from '@angular/http';
import { ApiInterceptor } from 'src/http.interceptor';
import { SCVService } from '../service/scv.service';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ToastService } from '../service/toast.sevice';
import { MessageService,ConfirmationService} from 'primeng/api';
import { InputSwitchModule } from 'primeng/inputswitch';
import { NewuploadComponent } from '../components/newupload/newupload.component';
import { ListboxModule } from 'primeng/listbox';
import { MatListModule } from '@angular/material/list';
import { RoutingModule } from './routing.module';
import { PrimengModule } from './primeng.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ErrorComponent } from '../components/error/error.component';
import { ConsentComponent } from '../components/newupload/consent/consent.component';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load(environment.configFile);
}

export function HttpLoaderFactory(http: HttpClient,appConfig: AppConfig) {
  return new TranslateHttpLoader(http, `${appConfig.getAppConfig().scvUploadUrl}/labeltranslations/`,"");
}

@NgModule({
  declarations: [
    ConsentComponent,
    AppComponent,
    NewuploadComponent,
    ErrorComponent
  ],
  imports: [
    PrimengModule,
    MatListModule,
    ListboxModule,
    InputSwitchModule,
    BrowserModule,
    RoutingModule,
    ProgressHttpModule,
    HttpModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient,AppConfig]
      },
      isolate: true
    }),
    NgCircleProgressModule.forRoot()
  ],
  entryComponents: [ConsentComponent, NewuploadComponent],
  providers: [
    AppConfig,
    ToastService,
    MessageService,
    ConfirmationService,
    SCVService,
    { provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true 
    },
    {provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true}],
  bootstrap: [AppComponent]
})

export class AppModule { }
